import React from 'react';
import { SearchIcon, XIcon } from '../../../components/icons';
import { TranscriptSearchProps } from '../../../types/transcript';

export default function TranscriptSearch({
    searchQuery,
    onSearchChange,
    resultCount,
    placeholder = 'Search transcript...'
}: TranscriptSearchProps) {
    const handleClearSearch = () => {
        onSearchChange('');
    };

    return (
        <div className="flex-1 relative">
            <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <SearchIcon className="h-5 w-5 text-gray-400" />
                </div>
                
                <input
                    type="text"
                    className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder={placeholder}
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
                
                {searchQuery && (
                    <div className="absolute inset-y-0 right-0 flex items-center">
                        <button
                            onClick={handleClearSearch}
                            className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
                            title="Clear search"
                        >
                            <XIcon className="h-4 w-4" />
                        </button>
                    </div>
                )}
            </div>
            
            {searchQuery && (
                <div className="absolute left-0 top-full mt-1 z-10">
                    <div className="bg-white border border-gray-200 rounded-md shadow-sm px-2 py-1">
                        <span className="text-xs text-gray-500">
                            {resultCount} result{resultCount !== 1 ? 's' : ''} found
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
}